module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABS0lEQVRIid2VsUoDQRCGvzuSFIJJYSNaSTCN+Bja2IqgrW+nPk0EIRG1tRFyESzujvwWN4thb/YajUX+5ob5/tvZ5Wb2kDRTW6Wkc0lIOpC0cDwLY5i3dDyzHJjQVh8YW7wHjBzPyBjm7TueSe4k/1TbUaBKsJBfdbwfWJlaowdcAEcRqIF7i5+Aa2AYeZbGAO6sWPyh3zJJHRv8vXrAIbAf5SvgEQjVj/FP8GxxBpzSPsE7kgpnQCTpxoZoLGnl8JUxzOupyJ2dBYXh2rEdxsqMrXtjDbdjDjZeYJlgIf/FTzetS8YAitQamSSvTWtgurbwBNiNPJ/A3OJkm/7LoJ3Rvioq4IFmlxlwRbsVC5orQjSnu8S5Kkj8iSTp1oboJMFlDPN6KnOnatDAnl2dFtggwfvbMQcbLzB38jXwavEH/jAujQG84P8Z59+zcUuFyD6YHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fwgl.png
// module id = phdJ
// module chunks = 28